import * as ClassicAlterListMembershipActionMetadataKeys from 'automation-ui-action-features/deprecated/alter-list-membership/ClassicAlterListMembershipActionMetadataKeys';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ContactListName from 'automation-ui-references/customer-data/ContactListName';
import { jsx as _jsx } from "react/jsx-runtime";
const displayType = {
  ACTION_DETAIL: 'actionDetail',
  ACTION_PREVIEW: 'actionPreview'
};
/**
 * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
 * Keeping around for backwards compatibility.
 */
const ClassicAlterListMembershipActionDetail = ({
  actionMetadata,
  messageLangPath = displayType.ACTION_DETAIL
}) => {
  const shouldAdd = actionMetadata.get(ClassicAlterListMembershipActionMetadataKeys.SHOULD_ADD);
  const listId = actionMetadata.get(ClassicAlterListMembershipActionMetadataKeys.LIST_ID);
  if (messageLangPath === displayType.ACTION_DETAIL) {
    return shouldAdd ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.alter-list-membership.action-detail.add",
      options: {
        listName: /*#__PURE__*/_jsx(ContactListName, {
          id: listId
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation-ui-action-features.action-features.alter-list-membership.action-detail.remove",
      options: {
        listName: /*#__PURE__*/_jsx(ContactListName, {
          id: listId
        })
      }
    });
  }
  return shouldAdd ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.alter-list-membership.action-preview.add",
    options: {
      listName: /*#__PURE__*/_jsx(ContactListName, {
        id: listId
      })
    }
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.alter-list-membership.action-preview.remove",
    options: {
      listName: /*#__PURE__*/_jsx(ContactListName, {
        id: listId
      })
    }
  });
};
export default ClassicAlterListMembershipActionDetail;